import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import svodMessages from '../../../locales/svod';
import Footer from '../footer';
import ThumbnailItem from '../thumbnail-item';
import SVODSideMenu from '../SVODSideMenu';
import NavigationBar from '../navigation-bar';
import { EnvType } from "../constants";

class CuratedPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			targetAssetVideoName: null,
		};

		this.isCuratedPage = this.props.curatedRow === this.props.selectedAssetRow;

		this.scrolling = this.scrolling.bind(this);
	}

	componentDidMount() {
		this.props.eventHandler({ data: { event_type: "page_enter", page_location: this.isCuratedPage ? "curated_page" : "view_all_page", time: Date.now()}});
		if (this.isCuratedPage) {
			this.props.eventHandler({ data: { event_type: "entered_curated_page"} });
		}
	}

	componentWillUnmount() {
		this.props.eventHandler({ data: { event_type: "page_exit", page_location: this.isCuratedPage ? "curated_page" : "view_all_page", time: Date.now()}});
	}

	componentDidUpdate() {
		if (this.isCuratedPage && this.props.promptTargetAsset && this.props.environment === EnvType.PEACOCK) {
			this.props.eventHandler({data: { event_type: 'prompt_target_asset', type: this.state.targetAssetVideoName } });
		}
		if (!this.isCuratedPage && this.props.promptReturnToHomePage && this.props.environment === EnvType.PEACOCK) {
			this.props.eventHandler({ data: { event_type: 'prompt_return_to_home_page', page_location: "view_all_page" } });
		}
	}

	scrolling (e, hasHero) {
		let index = document.querySelector(".index");

		var scrollh = index.scrollTop;
		if (scrollh <= 30 && hasHero) {
			index.classList.remove("small-title-section");
		}
		else if (scrollh > 30 && hasHero){
			index.classList.add("small-title-section");
		}
	}

	render() {
		const { 
			environment,
			selectedAssetRow,
			videos,
			rowInformation,
			pathTracker,
		} = this.props;

		if (!selectedAssetRow) {
			return (
				<div>{this.props.intl.formatMessage(svodMessages.no_row_selected)}</div>			
			);
		} else {
			let videosRow = videos[selectedAssetRow];
			let rowTitle;
			if (selectedAssetRow) {
				rowTitle = (selectedAssetRow.split("_")[0] === "Poster") ? (selectedAssetRow.split("_")[2]) : (selectedAssetRow.split("_")[0]);
			}
			
			let heroImage;
			let branding;
			let targetPaths;
			rowInformation.forEach((row) => {
				if (row.label === rowTitle) {
					heroImage = row.hero_image;
					branding = row.branding;
					targetPaths = row.paths;
				}
			});
			let videoIds = Object.keys(videosRow);
			let videoItems;
			videoItems = videoIds.map((videoId, idx) => {
				let disabledAsset = this.isCuratedPage;
				if (targetPaths && targetPaths[videoId]) {
					let possibleTargetPaths = targetPaths[videoId];
					possibleTargetPaths.forEach((conditions) => {
						if (conditions.length) {
							let selectedPaths = [];

							conditions.forEach((path_id) => {
								if (pathTracker && pathTracker.includes(path_id)) {
									selectedPaths.push(path_id);
								}
							});

							if (selectedPaths.length === conditions.length) {
								disabledAsset = false;

								if (!this.state.targetAssetVideoName) {
									let targetAsset = videosRow[videoId];
									this.setState({ targetAssetVideoName: targetAsset.content.title });
								}
							}
						}
					});
				}

				return <ThumbnailItem 
					key={`thumbnail`} 
					idx={idx} 
					disabledAsset={disabledAsset} 
					watchlist_video={false} 
					video={videosRow[videoId]} 
					label={selectedAssetRow} 
					page_location={this.isCuratedPage ? "curated_page" : "view_all_page"} 
					{...this.props} 
				/>;
			});

			return (
				<div className={`index curated-page-wrapper ${heroImage ? "" : "small-title-section"}`}
					id="svod-page" onScroll={(e) => this.scrolling(e, heroImage ? true : false)} >
					<div id="top"></div>
					{environment === EnvType.PEACOCK &&
						<SVODSideMenu {...this.props} page="curated" />
					}

					<img className="title-section-background" src={heroImage}></img>
					<div className="title-section" >
						<div className="small-title-section-background"></div>
						<div className={`title-section-content ${this.isCuratedPage ? "" : "non-curated-title-section-content"}`}>
							<div className="title-section-title">{rowTitle}</div>

							{this.isCuratedPage && branding &&
								<img loading="lazy" src={branding} className="title-section-sponsor" alt="Curated by Sponsor"></img>
							}
						</div>
					</div>
					<div className="curated-page">
						{videoItems}
					</div>

					<Footer environment={environment} />
				</div>
			);
		}
	}
}


const mapStateToProps = (state, ownProps) => ({
	videos: state.SVOD.videos,
	selectedAssetRow: state.SVOD.selectedAssets.assetRow,
	curatedRow: state.SVOD.selectedAssets.curatedRow,
	dropdown: state.SVOD.dropdown,
	volume: state.SVOD.volume,
	profilePictureNumber: state.SVOD.profilePictureNumber,
	environment: state.SVOD.environment,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	isSurveyActive: state.SVOD.isSurveyActive,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CuratedPage));



// WEBPACK FOOTER //
// ./src/components/svod/peacock/curated-page.jsx